// javascript
import React, { useState } from 'react';
import api from '../../../helper/util/api';
// import PropertyOwnerList from './PropertyOwnerList';

export default function MeetingRow({ data = null, onSaved, onCancel }) {
  // existing: if provided display readonly meeting
  const [form, setForm] = useState({
    meeting_type: data?.meeting_type || 'site_visit',
    mode: data?.mode || 'physical',
    datetime: data?.datetime ? data.datetime.replace(' ', 'T') : '',
    location: data?.location || ''
  });
  const [loading, setLoading] = useState(false);
  const [disableMode, setDisableMode] = useState(false);
  const [owners, setOwners] = useState(data?.owners || []);

  async function handleSave(dealId) {
    if (!form.datetime) return alert('Select date/time');
    setLoading(true);
    try {
      const localDate = new Date(form.datetime);   // interpreted as local time
      const isoUtc = localDate.toISOString();  
      const newOwners = owners.filter(r => r.isNew);

      const payload = {
        meeting_type: form.meeting_type,
        mode: form.mode,
        datetime: isoUtc,
        location: form.mode === 'physical' ? form.location : null,
        owners: newOwners
      };
      const res = await api.post(`/deals/${dealId}/meetings`, payload);
      onSaved && onSaved(res.data, 'add');
    } catch (err) {
      console.error(err);
      alert('Failed to schedule');
    } finally {
      setLoading(false);
    }
  }

  // async function updateMeetingStatus() {
  //   try {
  //     const payload = {
  //       leadId: window.__CURRENT_DEAL_ID__,
  //       meetingId: data.id,
  //     };
  //     const res = await api.post(`/meetingCompleted`, payload);
  //     if(res.status === 200 && onSaved)
  //       onSaved({...data, 'sv_completed': 1}, 'update');
  //   }catch (err) {
  //     console.error(err);
  //     alert('Failed to schedule');
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  const getMinDateTime = () => {
    // Get the current date and time
    const now = new Date();

    // Format the date and time to the required "YYYY-MM-DDTHH:mm" format
    // Pad single-digit months, days, hours, and minutes with a leading zero
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');

    const minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

    // Set the min attribute of the datetime-local input
    return minDateTime;
  }

  if (data) {
    return (
      <div className='meeting-list'>
        <div className="list-item">
          <div>
            <div style={{ fontWeight: 600 }}>{data.meeting_type.replace('_', ' ')}</div>
            <div className="meta">{data.mode} • {new Date(data.scheduled_at).toLocaleString()}</div>
            {data.location && <div className="small-muted">Location: {data.location}</div>}
          </div>
          <div className="meta action">
            {/* {
              (data.meeting_type === 'site_visit' && data.sv_completed === 0) && (
                <button onClick={updateMeetingStatus} disabled={loading}>Completed</button>
              )
            } */}
            <span>{new Date(data.created_at).toLocaleString()}</span>
          </div>
        </div>
        {/* {
          data.owners.length > 0 && (
            <div>
              <PropertyOwnerList owners={data.owners} showAction={false} />
            </div>
          )
        } */}
      </div>
    );
  }

  return (
    <div className="new-row">
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
        <div style={{ minWidth: 160 }}>
          <label className="label">Type</label>
          <select value={form.meeting_type} onChange={e => setForm({ ...form, meeting_type: e.target.value })}>
            <option value="site_visit">Site Visit</option>
            <option value="pre_closure">Pre Closure</option>
            <option value="closure">Closure</option>
          </select>
        </div>

        <div style={{ minWidth: 140 }}>
          <label className="label">Mode</label>
          <select value={form.mode} onChange={e => setForm({ ...form, mode: e.target.value })} disabled={disableMode}>
            <option value="physical">Physical</option>
            <option value="virtual">Virtual</option>
          </select>
        </div>

        <div style={{ flex: 1 }}>
          <label className="label">Date & Time</label>
          <input type="datetime-local" value={form.datetime} onChange={e => setForm({ ...form, datetime: e.target.value })} />
        </div>

        {form.mode === 'physical' && (
          <div style={{ minWidth: 220 }}>
            <label className="label">Location</label>
            <input type="text" value={form.location} min={getMinDateTime()} onChange={e => setForm({ ...form, location: e.target.value })} />
            <a className="btn btn-small ghost ml-5" target="_blank" href='https://www.google.com/maps/@16.5273577,78.6840483,5.37z' > Open Map </a>
          </div>
        )}
      </div>
      {/* {
        form.meeting_type !== "pre_closure" && (
          <div>
            <PropertyOwnerList owners={owners} setOwners={setOwners} acApiProps={{ leadId: window.__CURRENT_DEAL_ID__, acFor: 'meeting' }} />
          </div>
        )
      } */}

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <button className="btn-small ghost" onClick={onCancel} type="button">Cancel</button>
        <button className="btn-small" onClick={() => handleSave(window.__CURRENT_DEAL_ID__)} disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
}
